import "./WelcomeBanner.scss";

import React from "react";

interface WelcomeBannerProps {
    title: string;
    description: string;
    backgroundImgUrl: string;
    displayImgUrl: string;
}

const MyLearningBanner = ({
    title,
    description,
    displayImgUrl,
    backgroundImgUrl,
}: WelcomeBannerProps) => {
    return (
        <div className="welcome-banner">
            <img className="image-background" src={backgroundImgUrl} alt="" />
            <div className="welcome-banner__motto">
                <h1 className="welcome-banner__motto__title">{title}</h1>
                <div className="welcome-banner__motto__description">{description}</div>
            </div>
            <div className="welcome-banner__display-image-container">
                <img
                    src={displayImgUrl}
                    className="welcome-banner__display-image-container__image"
                />
                <svg width="0" height="0" xmlns="http://www.w3.org/2000/svg" version="1.1">
                    <defs>
                        <filter id="round">
                            <feGaussianBlur in="SourceGraphic" stdDeviation="5" result="blur" />
                            <feColorMatrix
                                in="blur"
                                mode="matrix"
                                values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9"
                                result="goo"
                            />
                            <feComposite in="SourceGraphic" in2="goo" operator="atop" />
                        </filter>
                    </defs>
                </svg>
            </div>
        </div>
    );
};

export default MyLearningBanner;
